export {setupConsentPersistence} from './inMemoryConsentPersistence';

const vendorMapping = {
  'youtube': 'YouTube Video',
  'google_tag_manager': 'Google Tag Manager',
  'google_universal_analytics': 'Google Analytics',
  'google_analytics4': 'Google Analytics 4'
};

export function handleConsentRequested({consent, usercentricsSettingsId}) {
  consent.requested().then(({vendors}) => {
    window.PAGFLOW_CONSENT_FOR_USERCENTRICS = consent;

    vendors.forEach(vendor => {
      const script = document.createElement('script');
      script.type = 'text/plain';
      script.text = `window.PAGFLOW_CONSENT_FOR_USERCENTRICS.accept('${vendor.name}')`;
      script.setAttribute('data-usercentrics', vendorMapping[vendor.name] || vendor.name);
      document.head.appendChild(script);
    });

    const script = document.createElement('script');
    script.id = 'usercentrics-cmp';
    script.src = 'https://app.usercentrics.eu/browser-ui/latest/loader.js';

    script.setAttribute('data-settings-id', usercentricsSettingsId)
    script.setAttribute('data-tcf-enabled', true)

    document.head.appendChild(script);
  });
}
